import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as PermissionsModels from '../../models/permissions/permissions';
import { EnvironmentService } from '../environment.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getRolePermissions(RoleId: number, isAdmin : boolean) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    if(isAdmin)
    {
      if(RoleId)
        return this.httpClient.post<PermissionsModels.PermissionsListModel>(`${this.environmentService.getApiURL()}/permissions/admin`, RoleId);
      else 
        return this.httpClient.get<PermissionsModels.PermissionsListModel>(`${this.environmentService.getApiURL()}/permissions/admin`);
    }else
    {
      if(RoleId)
        return this.httpClient.post<PermissionsModels.PermissionsListModel>(`${this.environmentService.getApiURL()}/permissions/customer`, RoleId);
      else 
        return this.httpClient.get<PermissionsModels.PermissionsListModel>(`${this.environmentService.getApiURL()}/permissions/customer`);
    }

  }
}
